import {
  Box,
  Stack,
  useTheme,
  Text,
  Button,
  LinearProgress,
  SxProps,
} from '@ltvco/refresh-lib/theme';

interface ReportUsageCardProps {
  reportsRun: number;
  reportsLimit: number;
  progressValue: number;
  onUpgradeClick: () => void;
  sx?: SxProps;
}

export const ReportUsageCard = ({
  reportsRun,
  reportsLimit,
  progressValue,
  onUpgradeClick,
  sx,
}: ReportUsageCardProps) => {
  const theme = useTheme();

  return (
    <Stack
      padding={1.5}
      spacing={1.5}
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(1),
        ...sx,
      }}
    >
      <Box display="flex" justifyContent="space-between" gap={1}>
        <Text fontWeight="bold">Reports</Text>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Text color="text.secondary" fontWeight="bold">
            {reportsRun}/{reportsLimit} left
          </Text>
        </Box>
      </Box>
      <Box>
        <LinearProgress
          value={progressValue}
          variant="determinate"
          sx={{
            height: theme.spacing(1),
            borderRadius: theme.spacing(0.5),
          }}
        />
      </Box>
      <Box>
        <Button
          variant="contained"
          size="small"
          fullWidth
          onClick={onUpgradeClick}
        >
          Upgrade your plan
        </Button>
      </Box>
    </Stack>
  );
};
